import { render } from "./ManageObjective.vue?vue&type=template&id=1ffc249d&scoped=true"
import script from "./ManageObjective.vue?vue&type=script&lang=js"
export * from "./ManageObjective.vue?vue&type=script&lang=js"

import "./ManageObjective.vue?vue&type=style&index=0&id=1ffc249d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffc249d"]])

export default __exports__